import { useContext } from 'react';

import { StoreContext } from './StoreProvider';

const useRootStore = () => {
  const rootStore = useContext(StoreContext);
  if (!rootStore) {
    throw new Error('Missing RootStore provider');
  }

  return rootStore;
};

export const useConfigurationStore = () => useRootStore().configurationStore;

export const useLocalizationStore = () => useRootStore().localizationStore;

export const useCategoryStore = () => useRootStore().categoryStore;

export const useMostCommonQuestionsStore = () => useRootStore().mostCommonQuestionsStore;

export const useSearchResultStore = () => useRootStore().searchResultStore;
